/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {resumeTile} from '../api'

export const useMutationResumeTile = createReactQueryMutationHook('resumeTile', resumeTile)
